module.exports = __webpack_public_path__ + "assets/img/icon-nodata.bd1be25a.png";